import { BehaviorSubject, timer } from 'rxjs';
import type { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import type { IMessage } from 'v2/interfaces/chat';

import apiService from './api';
import type { ApiService } from './api';

class ChatService {
  private messages$ = new BehaviorSubject<IMessage[]>([]);
  private isLoadingMessages$ = new BehaviorSubject<boolean>(true);

  constructor(private apiService: ApiService) {}

  public getChatUnreadCount(): Observable<number> {
    return timer(0, 2 * 60 * 1000).pipe(
      switchMap(() => this.apiService.get('/chat/count_unread')),
      map(response => response.data.total)
    );
  }

  public loadMessages(perPage: number) {
    this.apiService
      .get('chat', { per_page: perPage, page: 1 })
      .pipe(
        tap(() => this.isLoadingMessages$.next(true)),
        map(response => response.data.chats),
        tap(() => this.isLoadingMessages$.next(false))
      )
      .subscribe((messages: any) => this.messages$.next(messages));
  }

  public getMessages(): Observable<IMessage[]> {
    return this.messages$;
  }

  public getLoadingMessages(): Observable<boolean> {
    return this.isLoadingMessages$;
  }
}

const chatService = new ChatService(apiService);
export default chatService;
